{
    "TelnosmovedtoLabel": "Tel No(s) Moved To:",
    "DevicesmovedfromLabel": "Device(s) Moved From:",
    "AcdagentsmovedfromLabel": "ACD Agent(s) Moved From:",
    "AcdagentsmovedfromLabel_MST": "Agent(s) Moved From:",
    "CallsegmentnumberLabel": "Call Segment Number:",
    "CallsegmentnumberAnyOptionLabel": "[Any]",
    "CallsegmentnumberFirstOptionLabel": "[First]",
    "CallsegmentnumberFirstAfterFilteringOptionLabel": "[First - After Filtering]",
    "Callsegmentnumber2OptionLabel": "2",
    "Callsegmentnumber3OptionLabel": "3",
    "Callsegmentnumber4OptionLabel": "4",
    "Callsegmentnumber5OptionLabel": "5",
    "Callsegmentnumber6plusOptionLabel": "6+",
    "CallsegmentnumberLastOptionLabel": "[Last]",
    "CallsegmentnumberLastAfterFilteringOptionLabel": "[Last - After Filtering]",
    "CallsegmentstartreasonLabel": "Call Segment Start Reason:",
    "CallsegmentstartreasonAnyOptionLabel": "[Any]",
    "CallsegmentstartreasonDivertedtoOptionLabel": "Diverted To",
    "CallsegmentstartreasonOverflowedinOptionLabel": "Overflowed In",
    "CallsegmentstartreasonEscapedtoOptionLabel": "Escaped To",
    "CallsegmentstartreasonAdvancedtoOptionLabel": "Advanced To",
    "CallsegmentstartreasonTransferredtoOptionLabel": "Transferred To",
    "CallsegmentstartreasonConferencedtoOptionLabel": "Conferenced To",
    "CallsegmentstartreasonConferencedegenOptionLabel": "Conference De/Gen",
    "CallsegmentendreasonLabel": "Call Segment End Reason:",
    "CallsegmentendreasonAnyOptionLabel": "[Any]",
    "CallsegmentendreasonDivertedfromOptionLabel": "Diverted From",
    "CallsegmentendreasonOverflowedoffOptionLabel": "Overflowed Off",
    "CallsegmentendreasonEscapedfromOptionLabel": "Escaped",
    "CallsegmentendreasonAdvancedfromOptionLabel": "Advanced From",
    "CallsegmentendreasonTransferredfromOptionLabel": "Transferred From",
    "CallsegmentendreasonConferencedfromOptionLabel": "Conferenced From",
    "CallsegmentendreasonConferencedegenOptionLabel": "Conference De/Gen",
    "CallsegmentendreasonConsultationtrtoOptionLabel": "Consultation Tr/To",
    "CallsegmentendreasonMovedtoconferenceOptionLabel": "Moved To Conference",
    "CallsegmentendreasonMovedtoparkOptionLabel": "Moved To Park",
    "CallsegmentendreasonMovedtovoicemailOptionLabel": "Moved To Voice Mail",
    "CallsegmentendreasonEndedonholdonlyOptionLabel": "Ended On-Hold Only",
    "CallsegmentendreasonEndedonholdexclOptionLabel": "Ended On-Hold Excluded",
    "CallsegmentendreasonUnmonitoreddestOptionLabel": "Unmonitored Destination",
    "CallsegmentendreasonUnknowndestOptionLabel": "Unknown Destination",
    "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "All Unresolved Destinations Only",
    "CallsegmentendreasonAllunrslvddestexclOptionLabel": "All Unresolved Destinations Excluded",
    "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Modelling Errors Only",
    "CallsegmentendreasonModellingerrorsexclOptionLabel": "Modelling Errors Excluded",
    "CallsegmentendreasonApplicationendedOptionLabel": "Application Ended",
    "CallsegmentendreasonDevicedeletedOptionLabel": "Device Deleted",
    "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "No Reply Needed Emails Excluded",
    "CallsegmentStartEndReasonSupervisorTransferOptionLabel": "Supervisor Transfer",
    "CallsegmentchainidLabel": "Call Segment Chain ID (Application call ID):",
    "NAME": "CallMovementFiltering",
    "CallMovementFiltering_SectionHeader": "Call Movement Filtering",
    "CallMovementFiltering_AnyPlaceholder": "[Any]"
}
